export const LOGIN_USER_REQUEST = "LOGIN_USER_REQUEST";
export const LOGIN_USER_REQUEST_SUCCESS = "LOGIN_USER_REQUEST_SUCCESS"; 

export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_REQUEST_SUCCESS = "REGISTER_USER_REQUEST_SUCCESS";

export const LOGOUT = "LOGOUT";

export const ACCEPT_INVITE_REQUEST = "ACCEPT_INVITE_REQUEST";
export const ACCEPT_INVITE_REQUEST_SUCCESS = "ACCEPT_INVITE_REQUEST_SUCCESS";

export const GET_USER_REQUEST_SUCCESS = "GET_USER_REQUEST_SUCCESS";

export default (state = {}, action) => {
    switch (action.type){
        case REGISTER_USER_REQUEST_SUCCESS:
        case ACCEPT_INVITE_REQUEST_SUCCESS:
            return state;
        case GET_USER_REQUEST_SUCCESS:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}